const state = {
  all: [],
  loading: false
}

export const getters = {
  all: state => state.all,
  find: (state) => (id) => state.all.find((profileQualification) => profileQualification.id == id),
  loading: state => state.loading
}

export const mutations = {
  setAll(state, components) {
    state.all = JSON.parse(JSON.stringify(components))
    state.loading = false
  },
  remove(state, id) {
    state.all = state.all.filter(o => o.id != id)
  }
}

export const actions = {
  fetchAll({ commit, state }, profileQualification) {
    state.loading = true
    return api
      .getQualificationComponentsFor(profileQualification)
      .then(response => commit('setAll', response.data), error => (state.loading = false))
  },
  create({ commit, dispatch }, { profileQualification, profileQualificationComponent }) {
    state.loading = true
    return api
      .postCreateQualificationComponent(profileQualification, profileQualificationComponent)
      .then(data => {
        state.loading = false
        return data
      })
      .catch(errors => {
        state.loading = false
        return errors
      })
  },
  update({ commit, dispatch }, { profileQualification, profileQualificationComponent }) {
    state.loading = true
    return api
      .patchEditQualificationComponent(profileQualification, profileQualificationComponent)
      .then(data => {
        state.loading = false
        return data
      })
      .catch(errors => {
        state.loading = false
        throw errors
      })
  },
  delete({ commit, dispatch }, { profileQualification, profileQualificationComponent }) {
    state.loading = true
    return api
      .deleteQualificationComponent(profileQualification, profileQualificationComponent)
      .then(data => {
        state.loading = false
        return data
      })
      .catch(errors => {
        state.loading = false
        return errors
      })
  }
}

export const api = {
  getQualificationComponentsFor: profileQualification =>
    Vue.$http.get(`/candidate/profile_qualifications/${profileQualification.id}/profile_qualification_components`),
  postCreateQualificationComponent: (profileQualification, profileQualificationComponent) =>
    Vue.$http.post(`/candidate/profile_qualifications/${profileQualification.id}/profile_qualification_components`, {
      profileQualificationComponent
    }),
  patchEditQualificationComponent: (profileQualification, profileQualificationComponent) =>
    Vue.$http.patch(
      `/candidate/profile_qualifications/${profileQualification.id}/profile_qualification_components/${
        profileQualificationComponent.id
      }`,
      {
        profileQualificationComponent
      }
    ),
  deleteQualificationComponent: (profileQualification, profileQualificationComponent) =>
    Vue.$http.delete(
      `/candidate/profile_qualifications/${profileQualification.id}/profile_qualification_components/${
        profileQualificationComponent.id
      }`
    )
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
